import { useAuth } from "@/contexts/auth-context";
import { Link } from "react-router-dom";
import IcSendArrow from "@/components/icons/ic-send-arrow";

export const HeroBanner = () => {
  const { isAuthenticated } = useAuth();

  return (
    <section className="relative overflow-hidden bg-white lg:h-auto">
      <img
        src="/images/container-mobile.png"
        alt=""
        className="absolute w-full  object-cover pointer-events-none lg:hidden"
      />
      <div className="relative max-w-[1440px] mx-auto flex flex-col lg:flex-row lg:items-start lg:min-h-auto px-5 pt-10 pb-16 lg:pl-[100px] lg:pr-8 lg:pt-[10px] lg:pb-[61px]">
        <div className="flex-1 lg:w-full flex flex-col gap-12 lg:pt-[55px]">
          <div className="flex flex-col gap-3 lg:gap-6">
            {/* Badge — pill on mobile, simple rounded on desktop */}
            <span
              className="inline-flex items-center self-start px-3 py-2 text-caption font-bold text-black bg-white 
            border border-black/[0.15] shadow-[inset_0px_2px_10px_rgba(0,0,0,0.1)] 
            rounded-full lg:bg-[#EBEBEB] lg:border-none lg:shadow-none lg:rounded"
            >
              엔터프라이즈급 보안과 기술력의 결합
            </span>

            <h1 className="hidden lg:block text-[44px] font-bold leading-[48px] lg:text-[56px] lg:max-w-full lg:leading-[64px]  tracking-[-0.03em] lg:tracking-[-1.68px] max-w-[296px] text-black">
              검증된 AI 인텔리전스로
              <br /> 실현하는 비즈니스 임팩트
            </h1>

            <h1 className="block lg:hidden text-[44px] font-bold leading-[48px] lg:text-[56px] lg:max-w-[608px] lg:leading-[64px]  tracking-[-0.03em] lg:tracking-[-1.68px] max-w-full text-black">
              검증된 AI 인텔리전스로 실현하는 비즈니스 임팩트
            </h1>

            <p className="text-[16px] lg:text-[24px] leading-6 lg:leading-8 font-normal text-black tracking-[-0.48px] lg:max-w-full">
              엔터프라이즈 환경에 맞춤화된 통합 AI 아키텍처를 제공합니다.
              <br />
              단순 자동화를 넘어 데이터 자산의 가치를 극대화하고,
              <br /> 귀사의 지속 가능한 성장을 견인합니다.
            </p>
          </div>

          {/* CTA buttons */}
          <div className="flex gap-2 flex-col lg:flex-row lg:gap-3">
            <Link
              to={isAuthenticated ? "/chat" : "/signup"}
              className={`flex items-center justify-center h-12 bg-white md:bg-[#EBEBEB] rounded text-btn-md font-bold 
                text-black transition-colors ${isAuthenticated ? "w-full lg:w-[225px]" : "w-full lg:w-[315px] lg:flex-none"}`}
            >
              시작하기
            </Link>

            {isAuthenticated && (
              <Link
                to="/agents"
                className="flex items-center justify-center  h-12 bg-[#FFAA72] rounded lg:w-[225px] 
                 font-bold text-black transition-colors hover:bg-[#EE8A52]"
              >
                모든 에이전트 살펴보기
              </Link>
            )}
          </div>
        </div>

        <div className="hidden lg:flex flex-1 relative justify-end">
          <div className="relative">
            <img
              src="/images/hero-bn.png"
              alt="AI Marketplace"
              className="w-[571px] h-[556px]  relative z-10"
            />
            <div className="absolute bottom-[80px] left-[37px] z-20 w-[497px] flex flex-col gap-3">
              <p className="text-center text-body font-bold text-white">고객 만족도 95%</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
